import { createSelector } from 'reselect';

import { EEntityType } from '../../types/favoriteEntity';
import { IApplicationState } from '../../types/redux';

export const selectEntityTypeText = createSelector(
  (state: IApplicationState) => state.filters.favoriteEntityType,
  favoriteEntityType => {
    if (!favoriteEntityType) {
      return '';
    }

    const mapObject = {
      [EEntityType.Residential]: 'Городская',
      [EEntityType.Suburban]: 'Загородная',
      [EEntityType.Commercial]: 'Коммерческая',
      [EEntityType.Newbuilding]: 'Жилые комплексы',
    };

    return mapObject[favoriteEntityType];
  },
);
